import PageMain from '@/components/page-main';
import { useReducer } from 'react';
import useFetch from '@/hooks/useFetch';
import fetchValueReducer from '@/hooks/fetchValueReducer';
import { Table, Alert } from 'antd';

const Index: React.FC = () => {
  const [fetchValue, dispatchFetchValue] = useReducer(fetchValueReducer, { page: 1, size: 20, total: 1 });

  const { data, loading, fetchData } = useFetch("/local/chat/classification", { ...fetchValue }, dispatchFetchValue);

  const contentStyle = { fontSize: "12px", maxHeight: 150, overflowY: 'auto' } as React.CSSProperties;

  return <PageMain>
    <Table
      dataSource={data}
      columns={[
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'Chat_ID', dataIndex: 'chat_id', key: 'chat_id' },
        {
          title: '客户输入',
          dataIndex: 'user_msg',
          key: 'user_msg',
          render: _ => <Alert
            style={{
              whiteSpace: 'pre-wrap',
            }}
            description={<div style={contentStyle}>{_}</div>}
            type="info"
          />
        },
        {
          title: '意图分类',
          dataIndex: 'intent_class_returned',
          key: 'intent_class_returned',
        },
        { title: '创建时间', dataIndex: 'create_time', }
      ]}
      loading={loading}
      rowKey="id"
      pagination={{
        showSizeChanger: true,
        current: fetchValue.page,
        total: fetchValue.total,
        pageSize: fetchValue.size,
        pageSizeOptions: [10, 20, 50],
        onChange: (page, size) => {
          dispatchFetchValue({ type: 'update', value: { page, size } });
          fetchData();
        },
      }}
    />
  </PageMain>
}

export default Index;